<template>
  <b-row class="row" :style="'padding:15px 0px; background-color:' + backgroundColor">
    <b-col sm="6" md="4">
      <p>{{ Question.text }}</p>
    </b-col>
    <b-col sm="6" md="4">
      <v-select :options="yesNoOptions" :reduce="(x) => x.value" label="label" v-model="Question.isPassed"
        @input="changeAnswerEvent()"></v-select>
    </b-col>
    <b-col sm="12" md="4">
      <textarea type="text" class="form-control" placeholder="Uwagi" v-model="Question.comment"></textarea>
    </b-col>
  </b-row>
</template>

<script>
import ddOptions from "../../../mixins/dropDownOptions";

export default {
  name: "DeliveryQuestion",
  mixins: [ddOptions],
  data() {
    return {
      id: null,
      backgroundColor:
        this.Question.deliveryQuestionId % 2 ? "#FFF" : "#dee2e6",
    };
  },
  mounted() {
    this.id = this._uid;
  },
  props: {
    Question: {
      deliveryQuestionId: Number,
      text: String,
      isPassed: Boolean,
      comment: String,
    },
  },
  methods: {
    changeAnswerEvent() {
      this.$emit("DeliveryQuestionAnswer")
    }
  }
};
</script>
